export enum SurveyVariableConditionFilterCompanyProductScopeTypeEnum {
  None = 'none',
  All = 'all',
  Manual = 'manual',
  MyCompanyProducts = 'my_company_products',
}

export const SurveyVariableConditionFilterCompanyProductScopeTypeEnumLabels: Record<
  SurveyVariableConditionFilterCompanyProductScopeTypeEnum,
  string
> = {
  [SurveyVariableConditionFilterCompanyProductScopeTypeEnum.None]: 'Ningún producto',
  [SurveyVariableConditionFilterCompanyProductScopeTypeEnum.All]: 'Todos los productos',
  [SurveyVariableConditionFilterCompanyProductScopeTypeEnum.MyCompanyProducts]: 'Productos en los que participa la persona preguntada',
  [SurveyVariableConditionFilterCompanyProductScopeTypeEnum.Manual]: 'Selección manual de productos',
};

export const SurveyVariableConditionFilterCompanyProductScopeTypeEnumOptions: SurveyVariableConditionFilterCompanyProductScopeTypeEnum[] = [
  SurveyVariableConditionFilterCompanyProductScopeTypeEnum.None,
  SurveyVariableConditionFilterCompanyProductScopeTypeEnum.All,
  SurveyVariableConditionFilterCompanyProductScopeTypeEnum.MyCompanyProducts,
  SurveyVariableConditionFilterCompanyProductScopeTypeEnum.Manual,
];
